import initialState from 'redux/initialState';

import { EnvelopeWithStatus } from 'types/Envelope';
import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';

const envelopeReducer = (state = initialState.envelopes, action: any) => {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return initialState.envelopes;

    case 'SET_ENVELOPES':
      return action.payload;

    case 'UPDATE_ENVELOPE': {
      const envelopeId = action.payload.envelopeId || action.payload._id;
      const existingIndex = state.findIndex(
        (envelope: EnvelopeWithStatus) =>
          envelope.envelopeId === envelopeId || envelope._id === envelopeId
      );

      if (existingIndex !== -1) {
        return state.map((envelope: EnvelopeWithStatus, index: number) => {
          if (index === existingIndex) {
            return action.payload;
          }
          return envelope;
        });
      }

      return [...state, action.payload];
    }

    case 'UPDATE_ENVELOPE_STATUS':
      return state.map((envelope: EnvelopeWithStatus) => {
        if (envelope.envelopeId === action.payload.envelopeId) {
          return {
            ...envelope,
            envelopeStatus: action.payload.status,
          };
        }
        return envelope;
      });

    case 'CLEAR_ENVELOPES':
      return [];

    default:
      return state;
  }
};

export default envelopeReducer;
